import * as Sentry from "@sentry/react";

export const setAppContext = (ctx: {
  route?: string;
  startParam?: string;
  appVersion?: string;
  env?: string;
  network?: { downlink?: number; rtt?: number; effectiveType?: string };
}) => {
  Sentry.setContext("app", ctx);
  if (ctx.appVersion) Sentry.setTag("app_version", ctx.appVersion);

  if (ctx.env) Sentry.setTag("env", ctx.env);
};

export const setUserContext = (user?: {
  id?: string | number;
  username?: string;
  tonAddress?: string;
  locale?: string;
  country?: string;
}) => {
  Sentry.setUser(
    user?.id ? { id: String(user.id), username: user.username } : null,
  );
  Sentry.setContext("rep_user", {
    tonAddress: user?.tonAddress,
    locale: user?.locale,
    country: user?.country,
  });
};

export const crumb = (message: string, data?: Record<string, unknown>) => {
  Sentry.addBreadcrumb({
    category: "rep-miniapp",
    message,
    data,
    level: "info",
  });
};

export const logMsg = (
  message: string,
  level: "debug" | "info" | "warning" | "error" | "fatal" = "info",
  extra?: Record<string, unknown>,
) => {
  if (extra) Sentry.setContext("last_message_extra", extra);
  Sentry.captureMessage(message, level);
};

export const logEx = (
  err: unknown,
  hint?: string,
  extra?: Record<string, unknown>,
) => {
  if (extra || hint) {
    Sentry.setContext("exception_extra", { hint, ...extra });
  }
  Sentry.captureException(err instanceof Error ? err : new Error(String(err)));
};
